"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addKPIUnitByMetric = exports.replaceValueWhenNotNumber = void 0;
var types_1 = require("../types");
var generic_1 = require("./generic");
var replaceValueWhenNotNumber = function (formattedValue, noValuePlaceHolder) {
    return formattedValue !== "" && !isNaN(Number(formattedValue)) && !Number.isNaN(formattedValue) ? formattedValue : noValuePlaceHolder;
};
exports.replaceValueWhenNotNumber = replaceValueWhenNotNumber;
var addKPIUnitByMetric = function (params) {
    var binaryOccupancyParams = params.binaryOccupancyParams, comfortScoreFormatter = params.comfortScoreFormatter, dwellFormatter = params.dwellFormatter, getValueWithUnit = params.getValueWithUnit, noValuePlaceHolder = params.noValuePlaceHolder, scoreFormatter = params.scoreFormatter, type = params.type, value = params.value, isLive = params.isLive, _a = params.hideUnit, hideUnit = _a === void 0 ? false : _a;
    var _b = getValueWithUnit(type, value), unit = _b.unit, convertedValue = _b.value;
    var formattedValue = (0, exports.replaceValueWhenNotNumber)((0, generic_1.roundByMetric)(type, convertedValue), noValuePlaceHolder);
    var defaultValue = { valueAsString: formattedValue.toString(), unit: !hideUnit ? unit : "", rawValue: value };
    var hasCustomFormatter = (0, generic_1.isDefined)(dwellFormatter) || (0, generic_1.isDefined)(binaryOccupancyParams) || (0, generic_1.isDefined)(comfortScoreFormatter) || (0, generic_1.isDefined)(scoreFormatter);
    if (!hasCustomFormatter) {
        return defaultValue;
    }
    switch (type) {
        case types_1.RetailMetrics.DWELL:
        case types_1.RetailMetrics.WAITING_TIME: {
            if (!(0, generic_1.isDefined)(dwellFormatter))
                return defaultValue;
            var _c = (0, generic_1.decomposeDuration)(value), hours = _c.hours, minutes = _c.minutes, seconds = _c.seconds;
            var formattedDwell = dwellFormatter(hours, minutes, seconds);
            return { valueAsJSX: formattedDwell, rawValue: value };
        }
        case types_1.RetailMetrics.BINARY_OCCUPANCY:
            if (!isLive || formattedValue === noValuePlaceHolder || !(0, generic_1.isDefined)(binaryOccupancyParams)) {
                return defaultValue;
            }
            var firstKey = binaryOccupancyParams.firstKey, secondKey = binaryOccupancyParams.secondKey, formatter = binaryOccupancyParams.formatter;
            var key = Number(formattedValue) ? firstKey : secondKey;
            return {
                valueAsJSX: formatter(key),
                rawValue: value,
            };
        case types_1.RetailMetrics.COMFORT_SCORE: {
            if (!(0, generic_1.isDefined)(comfortScoreFormatter))
                return defaultValue;
            return {
                valueAsString: comfortScoreFormatter(defaultValue.valueAsString) || noValuePlaceHolder,
                rawValue: defaultValue.rawValue,
            };
        }
        case types_1.RetailMetrics.CO2_LEVEL_SCORE:
        case types_1.RetailMetrics.HUMIDITY_LEVEL_SCORE:
        case types_1.RetailMetrics.TEMPERATURE_SCORE:
        case types_1.RetailMetrics.TVOC_SCORE:
        case types_1.RetailMetrics.PM2_5_LEVEL_SCORE:
        case types_1.RetailMetrics.PM10_LEVEL_SCORE:
        case types_1.RetailMetrics.LUMINOSITY_SCORE:
        case types_1.RetailMetrics.PRESSURE_SCORE:
            if (!(0, generic_1.isDefined)(scoreFormatter))
                return defaultValue;
            return {
                valueAsString: scoreFormatter(defaultValue.valueAsString) || noValuePlaceHolder,
                rawValue: defaultValue.rawValue,
            };
        default:
            return defaultValue;
    }
};
exports.addKPIUnitByMetric = addKPIUnitByMetric;
